// Reduces a URL to a route shape that carries no patient data.
//
// posthog-js attaches $current_url / $pathname / $referrer to EVERY event it sends, including
// captureException — disabling pageview capture does not stop this. In this app a path like
// /patients/48213/consultations/9912 is PHI-adjacent, and the query string can be worse, so both
// are reduced before anything leaves the browser.

const ID_SEGMENT = /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

// Replaces numeric and UUID path segments with ":id" and drops the query and hash entirely.
export function redactUrl(value: unknown): string | undefined {
  if (typeof value !== "string" || value === "") {
    return undefined;
  }

  try {
    // `value` may be an absolute URL ($current_url) or a bare path ($pathname).
    const hasOrigin = /^https?:\/\//i.test(value);
    const url = new URL(value, hasOrigin ? undefined : "http://placeholder.invalid");

    const redactedPath = url.pathname
      .split("/")
      .map((segment) => (ID_SEGMENT.test(segment) ? ":id" : segment))
      .join("/");

    return hasOrigin ? `${url.origin}${redactedPath}` : redactedPath;
  } catch {
    // Never let a malformed URL leak through unredacted.
    return undefined;
  }
}
